import { render, staticRenderFns } from "./GerenciarConveniosFederais.vue?vue&type=template&id=38444283&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarConveniosFederais.vue?vue&type=style&index=0&id=38444283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38444283",
  null
  
)

export default component.exports